import { QueryCache, QueryClient } from '@tanstack/react-query';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

import { config } from '@/config/index';

import { persistedQueryKeys } from '@/api/queryKeys';

import { SessionExpiredError } from '@/api/core/client';

const MAX_AGE = config.cache.validityPeriod * 24 * 60 * 60 * 1000;

export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: MAX_AGE,
      retry: (failureCount, error) => !(error instanceof SessionExpiredError) && failureCount < 1,
    },
  },
});

persistedQueryKeys.forEach((key) => {
  queryClient.setQueryDefaults(key, { staleTime: MAX_AGE });
});

export const PERSISTED_CACHE_KEY = 'REACT_QUERY_OFFLINE_CACHE';

export const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: PERSISTED_CACHE_KEY,
});

export const persistOptions = {
  maxAge: MAX_AGE,
  buster: config.VERSION,
  dehydrateOptions: {
    shouldDehydrateQuery: (query: { queryKey: readonly unknown[] }) => {
      const [first, second] = query.queryKey as string[];
      return persistedQueryKeys.some(([k0, k1]) => k0 === first && (k1 === undefined || k1 === second));
    },
  },
};
